import { cn } from '@/helpers/utils/functionality-utils';

const ellipse = 'text-ellipsis overflow-hidden whitespace-nowrap';

export const EllipseLabel = ({
  label,
  noTitle,
  title,
  wrapText = false,
  className,
}: {
  label: string | number;
  title?: string | number;
  noTitle?: boolean;
  wrapText?: boolean;
  className?: string;
}) => {
  const _label = String(label);
  const _title = String(title);
  const _labelSplit = _label.split(' ');
  const setWrap = wrapText ? '' : ellipse;
  let renderLabel = <div className={setWrap}>{_label}</div>;
  if (_labelSplit[0]?.length === 1) {
    renderLabel = (
      <div className="flex min-w-0 items-center gap-1 whitespace-nowrap">
        {_labelSplit[0]}
        <div className={'min-w-0 ' + setWrap}>{_labelSplit[1]}</div>
      </div>
    );
  }
  return (
    <div
      title={noTitle ? undefined : title ? _title : _label}
      className={cn(`min-w-0`, className)}
    >
      {renderLabel}
    </div>
  );
};
